import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AnyType } from '@thehubz/shared/model';
import { UserAccessService } from '../user-access/user-access.service';

@Injectable()
export class RoleGuard {
  constructor(
    private router: Router,
    private userAccessService: UserAccessService,
  ) {}

  canActivate(data?: AnyType): boolean {
    if (data?.['role'] || data?.['roles']) {
      const roles = [].concat(data['role'] ?? data['roles']);
      const authorized = this.userAccessService.hasRoles(roles);
      if (!authorized) {
        if (data?.['redirect']) {
          this.router.navigate([data['redirect']]);
        } else {
          this.router.navigate(['/assets']);
        }
        return false;
      }
      return authorized;
    }
    return true;
  }
}

export const canActivateRoleRoute: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(RoleGuard).canActivate(route.data);
};
